
import React, { useState, useRef } from 'react';
import { LoadScript, Autocomplete } from '@react-google-maps/api';

const API_KEY = "AIzaSyCkD5TxhSIUbhRQb530WcEMa9qBSvdmNnM";  // Replace with your actual API key

export default function Location() {
    const [location, setLocation] = useState("");
    const autoCompleteRef = useRef(null);

    // Handle place selection
    const handlePlaceSelect = () => {
        if (autoCompleteRef.current) {
            const place = autoCompleteRef.current.getPlace();
            if (place && place.formatted_address) {
                setLocation(place.formatted_address);
            }
        }
    };

    return (
        <LoadScript googleMapsApiKey={API_KEY} libraries={['places']}>
            <div className="flex items-center justify-center px-6">
                <div className="wrapper rounded mx-auto w-[900px]">
                    <h1 className="text-[#1b1763] xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-semibold text-center py-4">
                        Enter your location
                    </h1>
                </div>
            </div>
            <div className="flex items-center justify-center">
                <form>
                    <div>
                        <label htmlFor="location" className="font-normal text-gray-600 text-base">
                            Location <span className="text-red-500">*</span>
                        </label>
                        <br />
                        <Autocomplete
                            onLoad={(autoC) => (autoCompleteRef.current = autoC)}
                            onPlaceChanged={handlePlaceSelect}
                        >
                            <input
                                id="location"
                                type="text"
                                value={location}
                                onChange={(e) => setLocation(e.target.value)}
                                placeholder="Enter your location"
                                className="md:text-2xl text-lg hover:border-[#F6BC29] md:w-[500px] sm:w-[400px] w-[300px] my-2 md:py-4 py-2 px-6 rounded-2xl bg-white border-2 transition-all duration-300 outline-none focus:border-[#F6BC29] focus:shadow-[#F6BC29] focus:shadow-md"
                            />
                        </Autocomplete>
                    </div>
                </form>
            </div>
        </LoadScript>
    );
}
